<template>
  <v-flex xs12 md12 lg12>
    <v-card>
      <v-card-text class="pt-32 pb-32 pl-22 pr-22">
        <h2 class="title mb-32 ml-1 mt-3">
          Estimated account value
          <v-icon
            class="vertical-align-middle icon-for-information"
            @click="
              () => {
                infoAlert(
                  $t('information.account_value.title'),
                  $t('information.account_value.description')
                );
              }
            "
            >fa-info-circle</v-icon
          >
        </h2>
        <v-layout row wrap>
          <v-flex class="xs12 md12 lg12 pl-10 pr-10">
            <router-link v-if="showSettingsLink" to="/settings">
              Connect an exchange.
            </router-link>
          </v-flex>
          <v-flex v-if="existForShow('Binance')" :class="exchangeCardClass">
            <v-card class="no-shadow fill-height">
              <v-toolbar class="toolbar-head">
                <v-toolbar-title>
                  <img
                    :src="'/img/Binance_logo.svg'"
                    width="20"
                    height="20"
                    alt="Binance"
                  />
                  <span>Binance</span>
                </v-toolbar-title>
              </v-toolbar>
              <div
                v-if="Object.keys(accountValues.Binance).length > 0"
                class="fill-height"
              >
                <v-list class="list-body mt-1 fill-height">
                  <div
                    v-for="(worth, coin, index) in accountValues.Binance"
                    :key="coin"
                  >
                    <v-list-tile class="mt-3 ml-2">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ worth | roundEstimatesAccountValue }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          coin
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                </v-list>
              </div>
              <div v-else>
                <v-flex class="pa-4"
                  >Your account value will be updated when you have one or more
                  <router-link :to="{ name: 'markets' }">markets selected</router-link></v-flex
                >
              </div>
            </v-card>
          </v-flex>
          <v-flex v-if="existForShow('Bittrex')" :class="exchangeCardClass">
            <v-card class="no-shadow fill-height">
              <v-toolbar class="toolbar-head">
                <v-toolbar-title>
                  <img
                    :src="'/img/Bittrex_logo.svg'"
                    width="20"
                    height="20"
                    alt="Bittrex"
                  />
                  <span>Bittrex</span>
                </v-toolbar-title>
              </v-toolbar>
              <div
                v-if="Object.keys(accountValues.Bittrex).length > 0"
                class="fill-height"
              >
                <v-list class="list-body mt-1 fill-height">
                  <div
                    v-for="(worth, coin, index) in accountValues.Bittrex"
                    :key="coin"
                  >
                    <v-list-tile class="mt-3 ml-2">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ worth | roundEstimatesAccountValue }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          coin
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                </v-list>
              </div>
              <div v-else>
                <v-flex class="pa-4"
                  >Your account value will be updated when you have one or more
                  <router-link :to="{ name: 'markets' }">markets selected</router-link></v-flex
                >
              </div>
            </v-card>
          </v-flex>
          <v-flex v-if="existForShow('Huobi')" :class="exchangeCardClass">
            <v-card class="no-shadow fill-height">
              <v-toolbar class="toolbar-head">
                <v-toolbar-title>
                  <img
                    :src="'/img/Huobi_logo.svg'"
                    width="20"
                    height="20"
                    alt="Huobi"
                  />
                  <span>Huobi</span>
                </v-toolbar-title>
              </v-toolbar>
              <div
                v-if="Object.keys(accountValues.Huobi).length > 0"
                class="fill-height"
              >
                <v-list class="list-body mt-1 fill-height">
                  <div
                    v-for="(worth, coin, index) in accountValues.Huobi"
                    :key="coin"
                  >
                    <v-list-tile class="mt-3 ml-2">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ worth | roundEstimatesAccountValue }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          coin
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                </v-list>
              </div>
              <div v-else>
                <v-flex class="pa-4"
                  >Your account value will be updated when you have one or more
                  <router-link :to="{ name: 'markets' }">markets selected</router-link></v-flex
                >
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import swal from "sweetalert2";

export default {
  props: {
    accountValues: {
      type: Object,
      default() {
        return { Binance: {}, Bittrex: {}, Huobi: {} };
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      themeDark: "settings/darkmode"
    }),
    showSettingsLink() {
      return this.user.exchanges_for_show.length == 0;
    },
    exchangeCardClass: function() {
      switch (this.user.exchanges_for_show.length) {
        case 1:
          return "xs12 md12 lg12 pl-10 pr-10";
        case 2:
          return "xs12 md6 lg6 pl-10 pr-10";
        case 3:
          return "xs12 md4 lg4 pl-10 pr-10";
        default:
          return "";
      }
    }
  },
  methods: {
    existForShow(exchange) {
      return !!this.user.exchanges_for_show.includes(exchange);
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    }
  }
};
</script>

<style scoped>
.theme--light .v-toolbar__title span {
  background: -webkit-linear-gradient(#468aff, #0051dd);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}

.theme--light .v-toolbar__title img {
  margin-right: 12px;
}

.theme--light .toolbar-head {
  background: #e6efff;
  border-radius: 10px;
  box-shadow: none !important;
}
.no-shadow {
  box-shadow: none !important;
}
.theme--light .list-body {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
}
.theme--dark .v-toolbar__title span {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.theme--dark .v-toolbar__title img {
  margin-right: 12px;
}
.theme--dark .list-body {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
}
.no-background {
  background: transparent;
}
>>> .theme--dark.v-toolbar {
  border-color: #424242;
  box-shadow: none;
  background: #303030;
  border-radius: 10px;
}
>>> .theme--light .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--dark .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
>>> .theme--light .v-list__tile__sub-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #7395d0;
}
>>> .theme--dark .v-list__tile__sub-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(235, 235, 245, 0.6);
}
.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.pa-32 {
  padding: 32px !important;
}
.pt-32 {
  padding-top: 32px;
}
.pb-32 {
  padding-bottom: 32px;
}
.ma-32 {
  margin: 32px;
}
.ml-32 {
  margin-left: 32px;
}
.mt-32 {
  margin-top: 32px;
}
.mb-32 {
  margin-bottom: 32px;
}
.pl-12 {
  padding-left: 12px !important;
}
.pr-12 {
  padding-right: 12px !important;
}
.pr-10 {
  padding-right: 10px !important;
}
.pl-10 {
  padding-left: 10px !important;
}
.pl-22 {
  padding-left: 22px !important;
}
.pr-22 {
  padding-right: 22px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/dashboard/AccountValue.vue